class SlabAdditionalShape {
  line;
  backsplashShapeId;

  constructor(line, backsplashShapeId) {
    this.line = line;
    this.backsplashShapeId = backsplashShapeId;
  }
}

export default SlabAdditionalShape;
